import React from "react";
import TablePagination from "@material-ui/core/TablePagination";
import { Grid } from "@material-ui/core";
const CustomPagination = ({
  total,
  rowsPerPageOptions,
  eventsPerPage,
  page,
  handleChangeRowsPerPage,
  onPageChange,
  disabledVal = false,
  fromTestLevelReportingMode
}) => {
  console.log("rowsPerPageOptions:", rowsPerPageOptions);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TablePagination
          rowsPerPageOptions={
            Array.isArray(rowsPerPageOptions)
              ? rowsPerPageOptions
              : [5, 10, 15, 20, 25]
          }
          style={{ borderBottom: "none",
            color: window.location.pathname === "/reporting-mode" && !fromTestLevelReportingMode ? "#fff" : "#000"
          }}
          count={total}
          page={page}
          onPageChange={onPageChange}
          rowsPerPage={eventsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage="Records per Page"
          disabled={disabledVal}
        />
      </Grid>
    </Grid>
  );
};

export default CustomPagination;